/**
 * @generated SignedSource<<b7c0d639c3683cf807302d749391956c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsStoreProductInfo$data = {
  readonly regularPrice: {
    readonly currency: string;
    readonly value: number;
  } | null;
  readonly specialPrices: ReadonlyArray<{
    readonly loyaltyOnly: boolean;
    readonly price: {
      readonly currency: string;
      readonly value: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsSpecialPriceDates">;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsPromotions" | "ProductDetailsStockInfo_StoreProduct">;
  readonly " $fragmentType": "ProductDetailsStoreProductInfo";
};
export type ProductDetailsStoreProductInfo$key = {
  readonly " $data"?: ProductDetailsStoreProductInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsStoreProductInfo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsStoreProductInfo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDetailsStockInfo_StoreProduct"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductPrice",
      "kind": "LinkedField",
      "name": "regularPrice",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductStoreSpecialPrice",
      "kind": "LinkedField",
      "name": "specialPrices",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsSpecialPriceDates"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductPrice",
          "kind": "LinkedField",
          "name": "price",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loyaltyOnly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductDetailsPromotions"
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};
})();

(node as any).hash = "8b74ca4295e788b6df853ecdaa74f0fe";

export default node;
